// features/drive/components/Upload/UploadDropdown.styles.js

import styled from 'styled-components';

export const Dropdown = styled.div`
  position: absolute;
  top: 46px;
  right: 0;
  width: 180px;

  background: ${({ theme }) => theme.landing.cardBg};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  border-radius: ${({ theme }) => theme.landingBorderRadius.lg};
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);

  overflow: hidden;

  z-index: 100;
`;

export const Item = styled.button`
  width: 100%;
  height: 42px;

  border: none;
  background: transparent;
  color: ${({ theme }) => theme.landing.text};

  text-align: left;

  padding: 0 16px;

  cursor: pointer;

  font-size: 14px;

  &:hover {
    background: ${({ theme }) => theme.landing.iconBg};
  }
`;
